<div class="like-list__header">
  <h2 class="like-list__title" mat-dialog-title>{{ title }}</h2>
  <button type="button" class="like-list__close" aria-label="Close" (click)="close()">
    <span class="material-icons" aria-hidden="true">close</span>
  </button>
</div>

<mat-dialog-content class="like-list__content">
  <ul class="like-list__users">
    @for (user of users.feedItems; track user.id) {
      <li class="like-list__user">
        <a class="like-list__user-link" uiSref="profile.about" [uiParams]="{ profileId: user.slug }" (click)="close()">
          <ut-avatar-badges [user]="user" aria-hidden="true"></ut-avatar-badges>
          <span class="like-list__user-text">
            <span class="like-list__user-name">{{ user.name }}@if (user.id === data.currentUserId) {<span class="sr-only">,&ngsp;</span><span class="like-list__you">You</span>}</span>
            <span class="like-list__user-slug">&#64;{{ user.slug }}</span>
          </span>
        </a>
        @if (user.current_user_permissions?.follow) {
          <ut-community-follow-btn [user]="user" design="2026" size="sm"></ut-community-follow-btn>
        }
      </li>
    }
  </ul>

  @if (users.isLoading) {
    <ut-loading-dots></ut-loading-dots>
  } @else if (!users.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm like-list__more" (click)="loadMore()">View more</button>
  }
</mat-dialog-content>
